import { ComponentStyleConfig, cssVar } from '@chakra-ui/react'
import { Dict } from '@chakra-ui/utils'
import { mode } from '@chakra-ui/theme-tools'

// The change of background color is implemented as they do in their repository.
// Reference: https://github.com/chakra-ui/chakra-ui/blob/main/packages/components/theme/src/components/tooltip.ts
const $bg = cssVar('tooltip-bg')

export const Tooltip: ComponentStyleConfig = {
  baseStyle: (props: Dict) => ({
    backgroundColor: mode(
      'rw1.secondary.light.8',
      'rw1.secondary.dark.8',
    )(props),
    _dark: {
      [$bg.variable]: 'colors.rw1.secondary.dark.8',
    },
    color: mode('rw1.text.light.8', 'rw1.text.dark.8')(props),
    borderRadius: 'lg',
    paddingY: 2,
    paddingX: 3,
    bg: $bg.reference,
    [$bg.variable]: 'colors.rw1.secondary.light.8',
  }),
}
